import { catchError, mergeMap } from 'rxjs/operators';
import React from 'react';
import { EMPTY } from 'rxjs';

import { ModalService } from 'ui-components/services/modal-service';

import { ErrorModal } from '../../components/modals/error-modal';
import { LocalDeliveryExceptionModalBody, LocalDeliveryExceptionModalTitle } from '../../components/modals/local-delivery-alert-modal';

import { bulkLoadFulfillmentPlans$ } from '../bulkload/bulkload.observables';

export const displayLocalDeliveryAlert = ({ data }) => {
  const { fulfillmentId, fulfillmentPlanId } = data;
  return bulkLoadFulfillmentPlans$([fulfillmentPlanId]).pipe(
    mergeMap(() => {
      ModalService.launchModal({
        component: ErrorModal,
        props: {
          title: LocalDeliveryExceptionModalTitle,
          message: <LocalDeliveryExceptionModalBody fulfillmentId={fulfillmentId} fulfillmentPlanId={fulfillmentPlanId} />,
        },
      });

      return EMPTY;
    }),
    catchError(() => EMPTY),
  );
};
